import React from 'react'
import * as Sentry from '@sentry/react'
import { Route, Routes } from 'react-router'
import { useTranslation } from 'react-i18next'

import About from './About'
import Contact from './Contact'
import Documentation from './Documentation'
import Main from './Main'
import Pricing from './Pricing'

import Layout from './components/Layout'

const ErrorFallback = () => (
    <div className="flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
        <button
            className="px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
            onClick={() => window.location.reload()}
        >
            Refresh page
        </button>
    </div>
)

const App = () => {
    const { t } = useTranslation()

    return (
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Main />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/documentation" element={<Documentation />} />
                    <Route path="*" element={<h1 className="text-3xl font-bold text-center py-20">{t('notFound')}</h1>} />
                </Route>
            </Routes>
        </Sentry.ErrorBoundary>
    )
}

export default App
